var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.782132 0.782132C1.27029 0.293977 2.06174 0.293977 2.5499 0.782132L9.99935 8.23158L17.4488 0.782132C17.937 0.293977 18.7284 0.293977 19.2166 0.782132C19.7047 1.27029 19.7047 2.06174 19.2166 2.5499L11.7671 9.99935L19.2166 17.4488C19.7047 17.937 19.7047 18.7284 19.2166 19.2166C18.7284 19.7047 17.937 19.7047 17.4488 19.2166L9.99935 11.7671L2.5499 19.2166C2.06174 19.7047 1.27029 19.7047 0.782132 19.2166C0.293977 18.7284 0.293977 17.937 0.782132 17.4488L8.23158 9.99935L0.782132 2.5499C0.293977 2.06174 0.293977 1.27029 0.782132 0.782132Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.08fab795.svg";
export { ForwardRef as ReactComponent };